import React, { useState } from 'react';
import { Option } from 'ui-builder';
import useDataLoader from '../../shared/uibuilder/form/dataLoader';
import CheckboxGroup from '../../shared/uibuilder/form/input/CheckboxGroup';
import LoadingAnimation from '../../shared/LoadingAnimation';
import { useProjectDocumentsService } from 'nekst-api';

export default function DocumentsCheckboxGroup(
  props: { projectId: number, labelClassName?: string },
) {
  const documentsService = useProjectDocumentsService();

  const [options, setOptions] = useState<Option<number>[]>();

  useDataLoader(
    async () => {
      const documents = await documentsService.getProjectDocuments(props.projectId);

      return documents.map((document) => {
        return {
          value: document.id,
          label: document._label?.name || '(without label)',
          hint: document?._file?.name || '',
        };
      });
    },
    setOptions,
  );

  if (options) {
    return (
      <CheckboxGroup
        options={options}
        label="Documents To Include"
        labelClassName={props.labelClassName}
        source="documentsIds"
        weights={[3, 3, 3, 3]}
      />
    );
  } else {
    return <LoadingAnimation />;
  }
}
